import { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';

import GridProvider from './GridProvider';
import { a11yProps, TabPanel } from '../../../../UI/MuiTab';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import Fajlovi from './Fajlovi';
import { useTranslation } from 'react-i18next';

const TabsProvider = ({
  izvestajSaTerena,
  bazaZnanja,
  handleClickNapomena,
}) => {
  const { t, i18n } = useTranslation();
  const [value, setValue] = useState(0);
  const [id, setId] = useState(0);
  const [openFajlovi, setOpenFajlovi] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const otvoriFajlove = (row) => {
    setOpenFajlovi(true);
    setId(row.id);
  };
  return (
    <>
      <Box sx={{ width: '98%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            style={{ padding: '2px' }}
          >
            <Tab
              label="Izveštaj sa terena"
              sx={{ textTransform: 'none' }}
              {...a11yProps(0)}
            />
            <Tab
              label="Baza znanja"
              sx={{ textTransform: 'none' }}
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      </Box>
      <TabPanel disabled value={value} index={0}>
        <GridProvider
          data={izvestajSaTerena}
          handleClickNapomena={handleClickNapomena}
          otvoriFajlove={otvoriFajlove}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GridProvider
          data={bazaZnanja}
          handleClickNapomena={handleClickNapomena}
          otvoriFajlove={otvoriFajlove}
        />
      </TabPanel>{' '}
      <MuiDialog
        maxWidth="lg"
        open={openFajlovi}
        title={t('files')}
        content={
          <div>
            <Fajlovi id={id} />
          </div>
        }
        handleClose={() => setOpenFajlovi(false)}
        deniedText="ZATVORI"
      />
    </>
  );
};

export default TabsProvider;
